import api from '../lib/api';
import { toArray } from '../lib/utils';
import type { WhatsappBalance, WhatsappBalanceFormData } from '../types/whatsappBalance';

export const whatsappBalanceService = {
  async getAll(): Promise<WhatsappBalance[]> {
    const response = await api.get('/whatsapp/balances');
    return toArray(response.data);
  },

  async getById(id: number): Promise<WhatsappBalance> {
    const response = await api.get(`/whatsapp/balances/${id}`);
    return response.data;
  },

  async create(data: WhatsappBalanceFormData): Promise<WhatsappBalance> {
    const response = await api.post('/whatsapp/balances', data);
    return response.data;
  },

  async update(id: number, data: WhatsappBalanceFormData): Promise<WhatsappBalance> {
    const response = await api.put(`/whatsapp/balances/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/whatsapp/balances/${id}`);
  },
};
